

//引入
import request from "../utils/request";
import wyqyId from "../config";
const api = {
    jcxxsjtj: function () {
        let params = {
            wyqyId: wyqyId
        }
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwyjcxx/jcxxsjtj",
        });
    },

}

export default api;